export function toHex(currencyAmount) {
    return currencyAmount.quotient.toString(10);
}
